import '../css/legend.css';
import { MARTIAL_COLOURS, MARTIAL_ICONS, MARTIAL_STRUCTURE } from './details';
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';

export default class Legend {
	constructor() {
		this.legend = document.getElementById('legend');
	}

	init() {
		this.setup();
	}

	setup() {
		const nationalitiesWrapper = document.getElementById('legend-nationalities');
		const nationalitiesFragment = this.getNationalitiesFragment();
		nationalitiesWrapper?.appendChild(nationalitiesFragment);

		const modesWrapper = document.getElementById('legend-modes');
		const modesFragment = this.getModesFragment();
		modesWrapper?.appendChild(modesFragment);

		if (!this.legend) return;
		this.legend.onclick = () => {
			this.legend?.classList.toggle('full');
		};

		OverlayScrollbars(this.legend, {
			overflow: {
				x: 'hidden',
				y: 'scroll'
			}
		});
	}

	getNationalitiesFragment() {
		const nationalities = MARTIAL_STRUCTURE.nemzetiség;
		const nationalitiesFragment = new DocumentFragment();
		for (let n = 0; n < nationalities.length; n++) {
			const nationality = nationalities[n];
			const colour = MARTIAL_COLOURS[nationality] || '#ffffff';
			const element = this.getNationalityLegend(nationality, colour);
			nationalitiesFragment.appendChild(element);
		}
		return nationalitiesFragment;
	}

	getModesFragment() {
		const modes = Object.keys(MARTIAL_ICONS);
		const modesFragment = new DocumentFragment();
		for (let m = 0; m < modes.length; m++) {
			const mode = modes[m];
			const icon = MARTIAL_ICONS[mode];
			if (!icon) continue;
			const element = this.getModeLegend(mode, icon);
			modesFragment.appendChild(element);
		}
		return modesFragment;
	}

	getModeLegend(mode, icon) {
		const element = document.createElement('div');
		element.classList.add('legend-element');
		const iconElement = document.createElement('div');
		iconElement.classList.add('legend-mode-icon');
		iconElement.innerHTML = icon;
		const label = document.createElement('div');
		label.classList.add('legend-label');
		label.textContent = mode;
		element.appendChild(iconElement);
		element.appendChild(label);
		return element;
	}

	getNationalityLegend(nationality, colour) {
		const element = document.createElement('div');
		element.classList.add('legend-element');
		const icon = document.createElement('div');
		icon.classList.add('legend-nationality-icon');
		icon.style.setProperty('--colour', colour);
		const label = document.createElement('div');
		label.classList.add('legend-label');
		label.textContent = nationality;
		element.appendChild(icon);
		element.appendChild(label);
		return element;
	}

	show() {
		this.legend?.classList.add('active');
	}

	hide() {
		this.legend?.classList.remove('active');
	}
}
